import {
    get,
    post,
    post2,
    put,
    put2,
    $delete
} from '@/plugins/axios.js'

export default {
    table(token, image) {
        return post(`https://aip.baidubce.com/rest/2.0/ocr/v1/table?access_token=${token}`, {
            cell_contents: false, return_excel: true, image
        });
    },
    /** 身份证  */
    idcard(token, base64,sign) {

        let data = {};
        data[sign] = base64;

        return post(`https://aip.baidubce.com/rest/2.0/ocr/v1/idcard?access_token=${token}`, data);
    },
    /** 银行卡  */
    bankcard(token, base64,sign) {
        let data = {};
        data[sign] = base64;

        return post(`https://aip.baidubce.com/rest/2.0/ocr/v1/bankcard?access_token=${token}`, data);
    },
    /** 驾驶证  */
    driving_license(token, base64,sign) {
        let data = {};
        data[sign] = base64;

        return post(`https://aip.baidubce.com/rest/2.0/ocr/v1/driving_license?access_token=${token}`, data);
    },
    /** 行驶证  */
    vehicle_license(token, base64,sign) {
        let data = {};
        data[sign] = base64;

        return post(`https://aip.baidubce.com/rest/2.0/ocr/v1/vehicle_license?access_token=${token}`, data);
    },
    /** 增值税发票  */
    vat_invoice(token, base64,sign) {
        let data = {};
        data[sign] = base64;

        return post(`https://aip.baidubce.com/rest/2.0/ocr/v1/vat_invoice?access_token=${token}`, data);
    },
    /** 定额发票  */
    quota_invoice(token, base64,sign) {
        let data = {};
        data[sign] = base64;

        return post(`https://aip.baidubce.com/rest/2.0/ocr/v1/quota_invoice?access_token=${token}`,data);
    },
    /** 营业执照  */
    business_license(token, base64,sign) {
        let data = {};
        data[sign] = base64;

        return post(`https://aip.baidubce.com/rest/2.0/ocr/v1/business_license?access_token=${token}`,data);
    },
    /** 火车票  */
    train_ticket(token, base64,sign) {
        let data = {};
        data[sign] = base64;

        return post(`https://aip.baidubce.com/rest/2.0/ocr/v1/train_ticket?access_token=${token}`, data);
    },
    /** 飞机票  */
    air_ticket(token, base64,sign) {
        let data = {};
        data[sign] = base64;

        return post(`https://aip.baidubce.com/rest/2.0/ocr/v1/air_ticket?access_token=${token}`,data);
    },
    /** 汽车票  */
    bus_ticket(token, base64,sign) {
        let data = {};
        data[sign] = base64;

        return post(`https://aip.baidubce.com/rest/2.0/ocr/v1/bus_ticket?access_token=${token}`, data);
    },
    /** 车牌  */
    license_plate(token, base64,sign) {
        let data = {};
        data[sign] = base64;

        return post(`https://aip.baidubce.com/rest/2.0/ocr/v1/license_plate?access_token=${token}`, data);
    },
    multiple_invoice(token, base64,sign){
        let data = {};
        data[sign] = base64;

        return post(`https://aip.baidubce.com/rest/2.0/ocr/v1/multiple_invoice?access_token=${token}`,data);
    },
    getToken() {
        return post(`/api/ocr/getToken`);
    },
    refreshToken() {
        return post(`/api/ocr/refreshToken`);
    },
    uploadTemplate(params) {
        return post(`/api/ocr/uploadTemplate`, params);
    },
    previewTemplate(params) {
        return post(`/api/ocr/previewTemplate`, params);
    },
    deleteTemplate(params) {
        return $delete(`/api/ocr/deleteTemplate`, params);
    },
    preReadExcel(params) {
        return post2(`/api/ocr/preReadExcel`, params);
    },
    post(formId, params) {
        return post(`/api/ocr/postData/${formId}`, params);
    }


}
